const TRUE_VALUES = new Set(["true", "1", "yes", "on"]);
const FALSE_VALUES = new Set(["false", "0", "no", "off"]);

const normalizeBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value !== "string") return null;
  const normalized = value.trim().toLowerCase();
  if (TRUE_VALUES.has(normalized)) return true;
  if (FALSE_VALUES.has(normalized)) return false;
  return null;
};

const normalizeNumber = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value !== "string") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const resolveLessonFlag = (lesson, field, defaultValue = false) => {
  const lessonValue = normalizeBoolean(lesson?.[field]);
  if (lessonValue !== null) return lessonValue;
  return defaultValue;
};

export const resolveLessonNumber = (lesson, field, defaultValue) => {
  const lessonValue = normalizeNumber(lesson?.[field]);
  if (lessonValue !== null) return lessonValue;
  return defaultValue;
};
